import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { BasketReturnModel, Money } from 'src/business/services/client.generated';
import { PricePipe } from 'src/core-lib/pipes/price.pipe';
import { BasketService } from '../../services/basket.service';

@Component({
    selector: 'app-basket-summary',
    templateUrl: './basket-summary.component.html',
    styleUrls: ['./basket-summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, TranslateModule,PricePipe]
})
export class BasketSummaryComponent implements OnDestroy {
    prices: Array<{ text: string, price: Money }> = [];
    subscription: Subscription;

    @Input('basket')
    set _basket(basket: BasketReturnModel) {
        this.prices = [];
        if (basket != null) {
            this.prices.push({ text: 'total_ex_vat', price: { amount: (basket?.total?.amount ?? 0) - (basket?.totalVat?.amount ?? 0), currency: (basket?.total?.currency ?? 'XXX') } });
            // if (basket.totalDiscount.amount > 0)
            //     this.prices.push({ text: 'total_shipping', price: basket.totalDiscount });
            // if (basket.totalDiscount.amount > 0)
            //     this.prices.push({ text: 'total_enviroment', price: basket.totalDiscount });
            if (basket?.totalVat != null)
                this.prices.push({ text: 'total_vat', price: basket.totalVat });
            if (basket?.totalDiscount?.amount > 0)
                if (basket?.totalDiscount != null)
                    this.prices.push({ text: 'total_discount', price: basket.totalDiscount });
            // if (basket.totalDiscount.amount > 0)
            //     this.prices.push({ text: 'total_invoice_fee', price: basket.totalDiscount });
            this.prices.push({ text: 'line', price: { amount: 0, currency: 'XXX' } });
            if (basket?.total != null)
                this.prices.push({ text: 'total_in_vat', price: basket.total });
        }
        this._detector.markForCheck();
    }

    constructor(private basketService: BasketService, private _detector: ChangeDetectorRef) {
        this.subscription = this.basketService.basket$.subscribe(basket => this._basket = basket);
    }

    ngOnDestroy(): void {
        if (this.subscription != null && !this.subscription.closed)
            this.subscription.unsubscribe();
    }
}
